import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { UserQualificationV2Attachment } from '@wilson/interfaces';
import { LocalizedDateFormatPipe } from '@wilson/localization';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'wilson-user-qualification-v2-details-attachment-section',
  imports: [
    FontAwesomeModule,
    NzCollapseModule,
    NzTooltipModule,
    TranslatePipe,
    LocalizedDateFormatPipe,
    DateFnsModule,
  ],
  templateUrl:
    './user-qualification-v2-details-attachment-section.component.html',
  styleUrl: './user-qualification-v2-details-attachment-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserQualificationV2DetailsAttachmentSectionComponent {
  @Input() userQualificationAttachments!:
    | UserQualificationV2Attachment[]
    | undefined;
  @Input() canReadUserQualificationV2Attachments = false;

  faPaperClip = faPaperclip;
}
